import { useFormikContext } from "formik";
import React from "react";
import { PicturePet } from "../../../../components/picture-pet";
import { IconButton } from "@material-ui/core";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
import { showToast, ToastType } from "../../../../utils/ToastUtil";
import { useToast } from "../../../../context/Toast/ToastProvider";
import { Delete } from "@material-ui/icons";
export const PicturePetSection = ({
  allowed_extensions = [".jpeg", ".jpg", ".png", ".gif"],
}) => {
  const { values, setFieldValue } = useFormikContext();
  const toastDispatch = useToast();

  const isValidExtension = (file) => {
    const extension = file.name
      .substring(file.name.lastIndexOf("."))
      .toLowerCase();
    return allowed_extensions.includes(extension);
  };
  const puppyFileChange = (e) => {
    const file = e.target.files[0];
    if (!file || !isValidExtension(file)) {
      const message = `El archivo no tiene una extensión permitida. Extensiones permitidas: ${allowed_extensions.join(
        ", "
      )}`;
      showToast(toastDispatch, message, ToastType.ERROR);
      return;
    }

    const urlValue = URL.createObjectURL(file);

    setFieldValue("imagePuppy", file);
    setFieldValue("urlPuppy", urlValue);
  };

  const puppyFileDelete = () => {
    setFieldValue("imagePuppy", null);
    setFieldValue("urlPuppy", null);
  };

  const adultFileChange = (e) => {
    const file = e.target.files[0];
    if (!file || !isValidExtension(file)) {
      const message = `El archivo no tiene una extensión permitida. Extensiones permitidas: ${allowed_extensions.join(
        ", "
      )}`;
      showToast(toastDispatch, message, ToastType.ERROR);
      return;
    }
    const urlValue = URL.createObjectURL(file);

    setFieldValue("imageAdult", file);
    setFieldValue("urlAdult", urlValue);
  };

  const adultFileDelete = (e) => {
    setFieldValue("imageAdult", null);
    setFieldValue("urlAdult", null);
  };

  return (
    <div>
      <div className="picture-pet-container">
        <div>
          <h2>Foto Cachorro</h2>
          <PicturePet url={values.urlPuppy} />
          <IconButton
            aria-label="image"
            disabled={values.changePhotoAttempts === 0}
            onClick={() => {
              if (values.urlPuppy || values.imagePuppy) {
                puppyFileDelete();
                const input = document.getElementById("image");
                if (input) input.value = null;
              } else {
                document.getElementById("image")?.click();
              }
            }}
          >
            {values.changePhotoAttempts === 0 ? null : (values.urlPuppy || values.imagePuppy) ? <Delete fontSize="medium" /> : <CameraAltIcon fontSize="medium" />}
          </IconButton>
          <input
            type="file"
            id="image"
            className="input-pet-hidden"
            accept="image/*"
            onChange={puppyFileChange}
          />
        </div>
        <div>
          <h2>Foto Adulto</h2>
          <PicturePet url={values.urlAdult} />

          <IconButton
            aria-label="image-adult"
            disabled={values.changePhotoAttempts === 0}
            onClick={() => {
              if (values.urlAdult || values.imageAdult) {
                adultFileDelete();
                const input = document.getElementById("image-adult");
                if (input) input.value = null;
              } else {
                document.getElementById("image-adult")?.click();
              }
            }}
          >
            {values.changePhotoAttempts === 0 ? null : (values.urlAdult || values.imageAdult) ? <Delete fontSize="medium" /> : <CameraAltIcon fontSize="medium" />}
          </IconButton>

          <input
            type="file"
            id="image-adult"
            className="input-pet-hidden"
            accept="image/*"
            onChange={values.changePhotoAttempts === 0 ? null : adultFileChange}
          />
        </div>
      </div>
      <div>
        {values.changePhotoAttempts === 0 ? (
          <p style={{ textAlign: "center", fontWeight: "bold" }}>
            No puede cambiar mas fotos de su mascota
          </p>
        ) : (
          <p style={{ textAlign: "center", fontWeight: "bold" }}>
            Tiene {values.changePhotoAttempts} intentos para cambiar la foto de
            su mascota.
          </p>
        )}
      </div>
    </div>
  );
};
